<!--
  找回密码
  lovi 2020-07-11
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('common.retrievePassword')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper logReg-field">
      <ul>
        <h4 class="title">{{ $t("logReg.fillAccount") }}</h4>
        <li>
          <van-cell-group>
            <van-field
              clearable
              left-icon="icon-name"
              v-model="username"
              :error="error.username ? true : false"
              @input="verifyUsername"
              :placeholder="$t('common.AccountFormat')"
            />
          </van-cell-group>
        </li>
        <li>
          <van-button round type="primary" block @click="checkUserName">
            {{ $t("common.nextStep") }}
          </van-button>
        </li>
      </ul>
    </div>

    <transition name="slide">
      <vue-email
        v-if="emailFlag"
        :emailFlag.sync="emailFlag"
        :setPsdFlag.sync="setPsdFlag"
        :username="username"
        @getEmail="getEmail"
      />
    </transition>

    <transition name="slide">
      <vue-encrypted
        v-if="encryptedFlag"
        :encryptedFlag.sync="encryptedFlag"
        :setPsdFlag.sync="setPsdFlag"
        :username="username"
        @getEncrypted="getEncrypted"
      />
    </transition>

    <transition name="slide">
      <set-psd
        v-if="setPsdFlag"
        :setPsdFlag.sync="setPsdFlag"
        @getSetPsd="getSetPsd"
      />
    </transition>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
import VueEmail from "@/views/personal/securitySet/email";
import VueEncrypted from "@/views/personal/securitySet/encrypted";
import SetPsd from "@/views/common/setPsd";
export default {
  name: "retrievePath",
  meta: {
    power: false, // 权限
    service: false // 客服
  },
  components: {
    VueEmail,
    VueEncrypted,
    SetPsd
  },
  data() {
    return {
      flag: 0, // 0邮箱 1密保
      username: "",
      error: {
        username: false
      },
      // 邮箱
      emailFlag: false,
      email: "",
      code: "",
      // 密保
      encryptedFlag: false,
      question: [],
      // 密码
      setPsdFlag: false
    };
  },
  created() {
    this.flag = this.$route.query.flag || 0;
  },
  mounted() {},
  computed: {},
  methods: {
    verifyUsername() {
      // 账号
      this.error.username = validate.validateUserName(this.username);
    },
    getEncrypted(data) {
      // 获取密保信息
      console.log("getEncrypted", data);
      this.question = data;
    },
    getEmail(data) {
      // 获取邮箱信息
      console.log("getEmail", data);
      this.email = data.email;
      this.code = data.code;
    },
    getSetPsd(data) {
      // 获取密码
      console.log("getSetPsd", data);
      if (this.flag == 0) {
        this.resetPwdEmail(data);
      }
      if (this.flag == 1) {
        this.questionResetPwd(data);
      }
    },
    checkUserName() {
      // 检查用户
      let vm = this;
      if (vm.username == "") {
        vm.$toast(vm.$t("common.enterAccount"));
        return false;
      }
      if (vm.error.username) {
        vm.$toast(vm.error.username);
        return false;
      }
      let params = {};
      params.username = vm.username;
      params.type = vm.flag == 0 ? 1 : 2;
      vm.$post("/app/user/checkUserName", params, { loading: true }).then(
        res => {
          console.log("checkUserName", res);
          if (vm.flag == 0) {
            vm.emailFlag = true;
          }
          if (vm.flag == 1) {
            vm.encryptedFlag = true;
          }
        }
      );
    },
    questionResetPwd(data) {
      let vm = this;
      let params = {};
      params.username = vm.username;
      params.question = vm.question;
      params.password = data;
      vm.$post("/app/user/questionResetPwd", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("questionResetPwd", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.$router.push({
            path: "/logReg"
          });
        }
      });
    },
    resetPwdEmail(data) {
      // 邮箱-重置密码
      let vm = this;
      let params = {};
      params.username = vm.username;
      params.email = vm.email;
      params.code = vm.code;
      params.password = data;
      vm.$post("/app/user/resetPwdEmail", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("resetPwdEmail", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.$router.push({
            path: "/logReg"
          });
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.title {
  margin-top: 30px;
  font-size: 14px;
  font-weight: 400;
}
/deep/.van-cell {
  align-items: center;
}
</style>
